export default "__VITE_ASSET__QFt3OW9K__"